import { Logger, LoggerSettings, LoggingLevel, LogLevel } from '@lender/utils';

import { IS_PRODUCTION } from 'constants/envs';
import { aiAggregator } from 'utils/aiAggregator';

export const logger = new Logger(
  'APP',
  new LoggerSettings({
    expand: {
      [LogLevel.INFO]: true,
      [LogLevel.LOG]: true,
      [LogLevel.WARN]: true,
      [LogLevel.ERROR]: true,
    },
    loggingLevel: IS_PRODUCTION ? LoggingLevel.ERROR : LoggingLevel.VERBOSE,
    internalLogger: window.console,
    aggregator: aiAggregator,
    aggregatorLoggingLevel: LoggingLevel.ERROR,
  }),
);
